import { ArrowUp, ArrowDown, Trash2, Plus } from "lucide-react";
import { moveItem } from "../../../../../utils/reorder";
import { removeById } from "../../../../../utils/remove";

export default function LessonFragmentsList({
                                          fragments,
                                          selectedFragmentId,
                                          onSelect,
                                          onChange,
                                          onDeleteRequest
                                      }) {
    const move = (from, to) => {
        onChange(moveItem(fragments, from, to));
    };

    return (
        <div>
            <div className="flex justify-between mb-3">
                <h2 className="font-bold">فرگمنت‌ها</h2>
                <button
                    onClick={() => {
                        const id = `frag_${fragments.length + 1}`;
                        onChange([...fragments, { id, blocks: [] }]);
                        onSelect(id);
                    }}
                    className="px-3 py-2 rounded-xl bg-blue-600 text-white text-sm flex gap-2"
                >
                    <Plus size={16} /> افزودن
                </button>
            </div>

            <div className="space-y-2">
                {fragments.map((f, index) => (
                    <div
                        key={f.id}
                        className={`p-3 rounded-xl border ${
                            f.id === selectedFragmentId
                                ? "bg-blue-50 border-blue-300"
                                : "bg-white"
                        }`}
                    >
                        <button
                            onClick={() => onSelect(f.id)}
                            className="w-full text-right font-medium"
                        >
                            {f.id}
                        </button>

                        <div className="flex justify-end gap-2 mt-2">
                            <button
                                disabled={index === 0}
                                onClick={() => move(index, index - 1)}
                            >
                                <ArrowUp size={16} />
                            </button>

                            <button
                                disabled={index === fragments.length - 1}
                                onClick={() => move(index, index + 1)}
                            >
                                <ArrowDown size={16} />
                            </button>

                            <button
                                onClick={() => onDeleteRequest(f.id)}
                                className="text-red-600"
                            >
                                <Trash2 size={16} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
